<template>
    <Modal class="order-payment-details-modal"
           :cancel="cancel"
           cancel-label="CLOSE"
           icon="fa-coins"
           title="ORDER_PAYMENT_DETAILS.MODAL_TITLE">
        <table class="table table-striped table-hover">
            <tbody>
                <tr>
                    <th>{{ l('ORDER_PAYMENT_DETAILS.TYPE') }}</th>
                    <td>{{ payment.paymentMethod.name }}</td>
                </tr>
                <tr>
                    <th>{{ l('ORDER_PAYMENT_DETAILS.STATUS') }}</th>
                    <td><PaymentStatusLabel :payment="payment" /></td>
                </tr>
                <tr v-if="payment.paymentMethod.supportsChange || payment.changeGiven != 0">
                    <th>{{ l('ORDER_PAYMENT_DETAILS.TENDERED') }}</th>
                    <td>{{ currencyFilter(payment.tendered) }}</td>
                </tr>
                <tr>
                    <th>{{ l('ORDER_PAYMENT_DETAILS.AMOUNT') }}</th>
                    <td>{{ currencyFilter(payment.amount) }}</td>
                </tr>
                <tr v-if="payment.paymentMethod.supportsChange || payment.changeGiven != 0">
                    <th>{{ l('ORDER_PAYMENT_DETAILS.CHANGE_GIVEN') }}</th>
                    <td>{{ currencyFilter(payment.changeGiven) }}</td>
                </tr>
                <tr v-if="payment.paymentMethod.supportsCashback || payment.cashback != 0">
                    <th>{{ l('ORDER_PAYMENT_DETAILS.CASHBACK') }}</th>
                    <td>{{ currencyFilter(payment.changeGiven) }}</td>
                </tr>
                <tr v-if="payment.paymentMethod.supportsGratuity|| payment.gratuity != 0">
                    <th>{{ l('ORDER_PAYMENT_DETAILS.GRATUITY') }}</th>
                    <td>{{ currencyFilter(payment.gratuity) }}</td>
                </tr>
                <tr>
                    <th>{{ l('ORDER_PAYMENT_DETAILS.TRANSACTION_REFERENCE') }}</th>
                    <td>{{ payment.transactionRef }}</td>
                </tr>
                <tr>
                    <th>{{ l('ORDER_PAYMENT_DETAILS.TAKEN_AT') }}</th>
                    <td>
                        <span v-if="payment.takenAt">
                            {{ dateFilter(payment.takenAt, true) }}
                        </span>
                    </td>
                </tr>
                <tr>
                    <th>{{ l('ORDER_PAYMENT_DETAILS.CONFIRMED_AT') }}</th>
                    <td>
                        <span v-if="payment.confirmedAt">
                            {{ dateFilter(payment.confirmedAt, true) }}
                        </span>
                    </td>
                </tr>
                <!--
                We should display the paymentChannel of a payment but at the moment this is not supplied by the API
                We could update API resolvers but paymentChannels are very static data why not just store the
                paymentChannels in IndexedDB and hydrate them from that.
                <tr>
                    <td>Payment channel</td>
                    <td>{{ payment.paymentChannel.name }}</td>
                </tr>
                -->
                <tr v-if="formattedStatusDetail">
                    <th>{{ l('ORDER_PAYMENT_DETAILS.DETAILS') }}</th>
                    <td>
                        <pre>{{ formattedStatusDetail }}</pre>
                    </td>
                </tr>
            </tbody>
        </table>
    </Modal>
</template>

<script>
import DateFormat from '@/lib/Dates/DateFormat';
import Modal from '@/vue/components/Modals/Modal';
import PaymentStatusLabel from '@/vue/components/Badges/PaymentStatusLabel';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';

export default {
    name: 'OrderPaymentDetailsModal',

    components: { PaymentStatusLabel, Modal },

    mixins: [
        ModalPropsMixin,
    ],

    props: {
        /**
         * @type {Payment}
         */
        payment: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            DateFormat,
        };
    },

    computed: {
        formattedStatusDetail() {
            // The status detail could be JSON. In which case lets return a nicely formatted string.
            try {
                const jsonParsed = JSON.parse(this.payment.statusDetail);
                if (jsonParsed) {
                    return JSON.stringify(jsonParsed, null, 2);
                }
            } catch (e) {
                // Guess it wasn't JSON.
            }

            return this.payment.statusDetail;
        },
    },
};
</script>

<style lang="less">
.order-payment-details-modal {
    table {
        tr {
            th {
                // Set a fixed width for the first columns with the headings.
                width: 180px; // Wide enough to fit the longest heading - "Transaction Reference"
            }
        }
    }

    pre {
        max-width: 470px; // Don't let the pre element grow too wide and make the table overflow.
        margin: 0;
    }
}
</style>
